import { render } from "./AddMouvement.vue?vue&type=template&id=454a80d0&scoped=true&ts=true"
import script from "./AddMouvement.vue?vue&type=script&lang=ts"
export * from "./AddMouvement.vue?vue&type=script&lang=ts"

import "./AddMouvement.vue?vue&type=style&index=0&id=454a80d0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-454a80d0"]])

export default __exports__